export default __webpack_public_path__ + "static/media/IBMPlexMono-Regular-Latin1.19239848.woff2";